import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment'

// Interfaces
import { IEmploymentType } from '@app/interfaces/employment-type.interface';

@Injectable({ providedIn: 'root' })
export class EmploymentTypeService {

    constructor(private http: HttpClient) { }

    getAll(): Observable<IEmploymentType[]> {
        return this.http.get<IEmploymentType[]>(environment.apiUrl + "/employment-types");
    }
}
